import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import PaymentHighlight from './PaymentHighlight';
import { PermissionsContext } from '../context/PermissionsContext';
import { HostAppCallbacksContextProvider } from '../context/HostAppCallbacksContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHighlight = styled.div.withConfig({
  displayName: "PaymentHighlightWrapper__StyledHighlight",
  componentId: "peh79j-0"
})(["border-bottom:1px solid ", ";padding:24px;"], BATTLESHIP);
const PaymentHighlightWrapper = ({
  objectId,
  permissions,
  onObjectUpdate,
  onObjectDelete,
  auth,
  closeSidebar
}) => {
  return /*#__PURE__*/_jsx(StyledHighlight, {
    children: /*#__PURE__*/_jsx(HostAppCallbacksContextProvider, {
      objectId: objectId,
      onObjectUpdate: onObjectUpdate,
      onObjectDelete: onObjectDelete,
      closeSidebar: closeSidebar,
      children: /*#__PURE__*/_jsx(PermissionsContext.Provider, {
        value: Object.assign({}, permissions, {
          user: auth.user
        }),
        children: /*#__PURE__*/_jsx(PaymentHighlight, {
          objectId: objectId
        })
      })
    })
  });
};
export default PaymentHighlightWrapper;